import React from 'react';
import { useWireInstructions } from './useWireInstructions';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import {
  TableWrapper,
  TableCell,
  TableRow,
  TableBody,
} from '../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { WireInstructionsLoading } from './WireInstructions.loading';

export const WireInstructions = () => {
  const { isLoading, data } = useWireInstructions();

  if (isLoading) {
    return <WireInstructionsLoading />;
  }

  if (!data) {
    return null;
  }

  return (
    <>
      <TableWrapper as="table" variant="embedded" css="display: flex; flex-direction: column">
        <Text px={24} py={18} color="neutral.500" as="caption" textAlign="left">
          Please provide the following information to your bank:
        </Text>
        <TableBody as="tbody">
          {data.map(({ label, value }) => (
            <TableRow px="24" key={label} as="tr">
              <TableCell
                width={160}
                as="th"
                scope="row"
                fontSize="body"
                fontWeight={500}
                color="neutral.500"
              >
                {label}
              </TableCell>
              <TableCell width={388} as="td" fontSize="body" fontWeight={500}>
                {value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </TableWrapper>

      <Box borderWidth="1px 0 0 0" borderStyle="solid" borderColor="neutral.200" px={24} py={12}>
        <Text as="strong" fontWeight={600}>
          Please Note:
        </Text>
        <Text my={10} color="neutral.500" as="p">
          Domestic wires can take 1-3 business days and your bank may charge you a processing fee.
        </Text>
      </Box>
    </>
  );
};
